import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";
import { ReactComponent as Logo } from "./assets/doormat.svg";

export class index extends Component {
  state = {
    tracking_id: "",
    loading: false,
    failed: false,
  };
  componentDidMount() {
    window.scrollTo(0, document.body.scrollHeight);
  }

  render() {
    const { language, customTexts } = this.props;
    return (
      <div style={{ backgroundColor: "white" }} className="h-100">
        <ProductHeader
          style={{ backgroundColor: "white" }}
          onBack={() =>
            this.props.history.goBack({
              waiting_list: this.props.history.location.state.waiting_list,
            })
          }
        />
        <div
          className="free-space-58"
          style={{ backgroundColor: "white" }}
        ></div>

        <div style={{ marginTop: "55px" }}>
          <Logo width="150" height="150" className="mt-4" />
          <p className="text-muted mt-5 mb-0" style={{ fontSize: 22 }}>
            {language == "english"
              ? customTexts.no_waiting_list
              : customTexts.no_waiting_list_ar}
          </p>

          <div
            className="free-space-115"
            style={{ backgroundColor: "white" }}
          ></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customTexts: state.store.store.settings.custom_texts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
